module.exports = __webpack_public_path__ + "media/luxury-2026/terrace-living-960-9f07428b.jpg";